import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWalletBalanceApi, fetchAepsBalanceApi, fetchLienBalanceApi, fetchSettlementBalanceApi, } from "../../CustomHooks/Api";

// Existing wallet balance thunk
export const fetchWalletBalance = createAsyncThunk(
  "wallet/fetchBalance",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const username = state.auth.employeeDetails?.username;
    const accountNo = state.auth.employeeDetails?.merchant_account_no;
    const token = state.auth.employeeDetails?.token;
    try {
      const data = await fetchWalletBalanceApi(username, accountNo, token);
      return data.balance;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch balance");
    }
  }
);

// AEPS balance thunk
export const fetchAepsBalance = createAsyncThunk(
  "wallet/fetchAepsBalance",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const username = state.auth.employeeDetails?.username;
    const accountNo = state.auth.employeeDetails?.merchant_account_no;
    const token = state.auth.employeeDetails?.token;
    try {
      const data = await fetchAepsBalanceApi(username, accountNo, token);
      return data.balance;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch AEPS balance");
    }
  }
);

// Fixed lien balance thunk
export const fetchLienBalance = createAsyncThunk(
  "wallet/fetchLienBalance",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const username = state.auth.employeeDetails?.username;
    const token = state.auth.employeeDetails?.token;
    try {
      console.log("Calling lien balance API with username:", username);
      const data = await fetchLienBalanceApi(username, token);
      console.log("Lien balance API response:", data);

      // Handle different possible response formats
      if (typeof data === 'number') {
        return data;
      } else if (data?.balance !== undefined) {
        return data.balance;
      } else if (data?.lienAmount !== undefined) {
        return data.lienAmount;
      } else if (data?.lien_amount !== undefined) {
        return data.lien_amount;
      } else {
        console.warn("Unexpected lien balance response format:", data);
        return 0;
      }
    } catch (error) {
      console.error("Lien balance fetch error:", error);
      return thunkAPI.rejectWithValue("Failed to fetch lien balance");
    }
  }
);

export const fetchSettlementBalance = createAsyncThunk(
  "wallet/fetchSettlementBalance",
  async (_, thunkAPI) => {
    const state = thunkAPI.getState();
    const username = state.auth.employeeDetails?.username;
    const token = state.auth.employeeDetails?.token;
    const accountNo = state.auth.employeeDetails?.merchant_account_no;

    try {
      const data = await fetchSettlementBalanceApi(username, accountNo, token);

      // Safe response handling
      if (typeof data === "number") return data;
      if (data?.balance !== undefined) return data.balance;
      if (data?.settlementBalance !== undefined) return data.settlementBalance;
      if (data?.commissionBalance !== undefined) return data.commissionBalance;

      console.warn("Unexpected settlement balance response:", data);
      return 0;
    } catch (error) {
      return thunkAPI.rejectWithValue("Failed to fetch settlement balance");
    }
  }
);


const walletSlice = createSlice({
  name: "wallet",
  initialState: {
    balance: 0,
    loading: false,
    error: null,
    aepsBalance: 0,
    aepsLoading: false,
    aepsError: null,
    lienBalance: 0,
    lienLoading: false,
    lienError: null,
    settlementBalance: 0,
    settlementLoading: false,
    settlementError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Wallet balance cases
      .addCase(fetchWalletBalance.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchWalletBalance.fulfilled, (state, action) => {
        state.loading = false;
        state.balance = action.payload;
      })
      .addCase(fetchWalletBalance.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // AEPS balance cases
      .addCase(fetchAepsBalance.pending, (state) => {
        state.aepsLoading = true;
        state.aepsError = null;
      })
      .addCase(fetchAepsBalance.fulfilled, (state, action) => {
        state.aepsLoading = false;
        state.aepsBalance = action.payload;
      })
      .addCase(fetchAepsBalance.rejected, (state, action) => {
        state.aepsLoading = false;
        state.aepsError = action.payload;
      })
      // Settlement / Commission balance cases
      .addCase(fetchSettlementBalance.pending, (state) => {
        state.settlementLoading = true;
        state.settlementError = null;
      })
      .addCase(fetchSettlementBalance.fulfilled, (state, action) => {
        state.settlementLoading = false;
        state.settlementBalance = action.payload;
      })
      .addCase(fetchSettlementBalance.rejected, (state, action) => {
        state.settlementLoading = false;
        state.settlementError = action.payload;
      })

      // Lien balance cases
      .addCase(fetchLienBalance.pending, (state) => {
        state.lienLoading = true;
        state.lienError = null;
      })
      .addCase(fetchLienBalance.fulfilled, (state, action) => {
        state.lienLoading = false;
        state.lienBalance = action.payload;
      })
      .addCase(fetchLienBalance.rejected, (state, action) => {
        state.lienLoading = false;
        state.lienError = action.payload;
      });


  },
});

export default walletSlice.reducer;